module.exports = __webpack_public_path__ + "img/3.e43d2be7.png";